/**
 * BoletoModal — dados do boleto de uma fatura e download.
 *
 * **Não cancela boleto.** Boleto só é cancelado pelo cancelamento da FATURA: quem tem boleto
 * dispara CANCEL_BILL ao biller e a fatura só fecha quando o BOLETO_CANCELED volta. Ter dois
 * caminhos para o mesmo efeito convidava a cancelar o boleto e deixar a fatura em cobrança.
 * Ver `CancelInvoiceModal`.
 *
 * Download: pendente — o biller ainda não expõe endpoint do PDF (só o fileName no S3).
 */
import { FaTimes, FaBarcode, FaDownload } from 'react-icons/fa';

interface Props {
    invoice: any;
    onClose: () => void;
}

const BoletoModal: React.FC<Props> = ({ invoice, onClose }) => {
    const boleto = invoice.boleto || {};

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]" onClick={onClose}>
            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl p-6 max-w-md w-full mx-4" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2" title={invoice.invoiceId}>
                        <FaBarcode className="text-blue-500" />
                        Boleto — Fatura {invoice.invoiceId ? invoice.invoiceId.slice(0, 8) : ''}
                    </h2>
                    <button onClick={onClose} aria-label="Fechar"
                            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                        <FaTimes size={20} />
                    </button>
                </div>

                <div className="mb-4 text-sm space-y-1">
                    <div className="flex justify-between">
                        <span className="text-gray-500 dark:text-gray-400">Nosso número</span>
                        <span className="font-mono text-gray-900 dark:text-gray-100">{boleto.ourNumber || '-'}</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500 dark:text-gray-400">Id do boleto</span>
                        <span className="font-mono text-xs text-gray-900 dark:text-gray-100 break-all text-right max-w-[240px]">{boleto.boletoId || '-'}</span>
                    </div>
                </div>

                <button
                    disabled
                    title="Em breve — o biller ainda não expõe endpoint de download do PDF"
                    className="w-full flex items-center justify-center gap-2 px-4 py-2 text-sm rounded bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-slate-700 dark:text-slate-500"
                >
                    <FaDownload /> Baixar boleto (em breve)
                </button>

                <p className="text-xs text-gray-500 mt-3">
                    Para parar de cobrar este boleto, cancele a fatura — o cancelamento é enviado ao
                    banco e a fatura fecha quando o banco confirma.
                </p>
            </div>
        </div>
    );
};

export default BoletoModal;
